<template>
	<div>
		<Subpage/>
		 	<div class="page-content container">
        		<main>           
					<h1 class="page-title">Polityka prywatności</h1>          
				<div class="breadcrumbs-area">
					<nav aria-label="breadcrumb">
						<ol class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
							<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
								<router-link itemprop="item" to="/" >
									<span itemprop="name">Strona gł&oacute;wna</span>
								</router-link><span class="separator">/</span>
							</li>
							<li class="active">Polityka prywatności
							</li>
						</ol>
					</nav>
				</div>          
	    			<h2>Polityka Prywatności serwisu www.kontur.it</h2>
					<p>Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych, przekazanych przez Użytkownik&oacute;w w związku z korzystaniem przez nich z serwisu www.kontur.it.</p>
					<ol>
						<li>Administratorem danych osobowych, zawartych w serwisie www.kontur.it, jest firma <strong>Kontur.IT Sp. z o.o</strong> z siedzibą w Gliwicach, ul. Szenwalda 12, 44-113 Gliwice</li>
						<li>Dane osobowe przetwarzane są na podstawie zgody wyrażonej przez Użytkownika lub w celu realizacji zawartej umowy.</li>
						<li>Serwis pozyskuje informacje o Użytkownikach i ich zachowaniach poprzez:
						<ul>
							<li>informacje dobrowolnie wprowadzone w formularzach</li>
							<li>pliki &ldquo;cookies&rdquo;</li>
						</ul>
						</li>
						<li>Przekazane dane przetwarzane są w celu wynikającym z funkcji konkretnego formularza, np. w celu odpowiedzi na zadane pytanie.</li>
						<li>Osoba, kt&oacute;ra umieściła dane w formularzu, ma prawo do wglądu, modyfikacji oraz żądania zaprzestania przetwarzania swoich danych w dowolnym momencie.</li>
						<li>Zastrzegamy sobie prawo do zmian w Polityce Prywatności serwisu. Wszelkie zmiany zostaną niezwłocznie udostępnione na stronie.</li>
					</ol>
					<h2>Polityka Wykorzystywania Plik&oacute;w Cookies w serwisie www.kontur.it</h2>
					<p>Pliki cookies to dane informatyczne, przechowywane na urządzeniach końcowych Użytkownik&oacute;w, przeznaczone do korzystania ze stron internetowych. Nie pozwalają one na jednoznaczną identyfikację Użytkownika.</p>
					<ol>
						<li>Serwis www.kontur.it nie zbiera w spos&oacute;b automatyczny żadnych informacji, z wyjątkiem zawartych w plikach cookies. Należą do nich: adres IP, nazwa domeny, typ przeglądarki, rodzaj systemu operacyjnego oraz dane o ścieżce nawigacji Użytkownika i o czasie jego pozostawania na określonych podstronach.</li>
						<li>Operatorem serwisu www.kontur.it jest firma <strong>Kontur.IT Sp. z o.o</strong> z siedzibą w Gliwicach, ul. Szenwalda 12, 44-113 Gliwice</li>
						<li>Operator wykorzystuje pliki cookies w celu:
						<ul>
							<li>zwiększenia użyteczności strony internetowej i dopasowania jej zawartości do indywidualnych preferencji Użytkownika&nbsp;</li>
							<li>tworzenia anonimowych statystyk - z wyłączeniem możliwości identyfikacji Użytkownika.</li>
						</ul>
						</li>
						<li>Użytkownik może w dowolnym momencie dokonać zmiany ustawień plik&oacute;w cookies w swojej przeglądarce. Zmiany te mogą jednak uniemożliwić poprawne działanie serwisu.</li>
					</ol>
					<p><strong>Pytania dotyczące Polityki Prywatności i Polityki Wykorzystywania Plik&oacute;w Cookies prosimy kierować na adres: biuro@kontur.it.</strong></p>
        		</main>
    </div>
	</div>
</template>
<script>
import Subpage from '@/components/Subpage.vue'
export default {
  name: 'PrivacyPolicy',
  components: {
    Subpage
  }
}
</script>